import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HomeButtonComponent } from '../scootaverse/components/home-button/home-button.component';

import { ScaleSurveyCardComponent } from './components/scale-survey-card/scale-survey-card.component';
import { SelectorSurveyComponent } from './components/selector-survey/selector-survey.component';
import { TextInputSurveyCardComponent } from './components/text-input-survey-card/text-input-survey-card.component';
import { SurveyCardComponent } from './survey-card/survey-card.component';

@NgModule({
  declarations: [SurveyCardComponent, ScaleSurveyCardComponent, TextInputSurveyCardComponent, SelectorSurveyComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatRadioModule,
    MatFormFieldModule,
    NgbModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    HomeButtonComponent,
  ],
  providers: [],
})
export class SurveyModule {}
